export default "__VITE_ASSET__D3fVvB3Q__"